import React from 'react';
import { connect } from 'react-redux';

import { getVehiclesData } from '../../../redux/operational-dashboard-vehicles';
import Map from './components/Map';
import OperationalDashboard from '../index';
import VehiclesList from './components/VehiclesList';
import LeftColumn from './components/Columns/LeftColumn';
import RightColumn from './components/Columns/RightColumn';
import OperationalDashboardCard from '../components/OperationalDashboardCard';
import InfoWithProgressLine from '../components/InfoWithProgressLine';

import './styles.css';

class Distribution extends React.Component {
  componentDidMount() {
    this.props.getVehiclesData();
    this.interval = setInterval(() => {
      this.props.getVehiclesData();
    }, 300000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const {
      data,
    } = this.props;

    return (
      <OperationalDashboard>
        <div className="OperationalDashboardVehiclesMap__root">
          <Map
            notPassCompanyId
            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDNV7mHyjuTm0VC8ZZnW90OTZWrvBnXIaw&v=3.exp&libraries=geometry,drawing,places"
            loadingElement={<div className="OperationalDashboardVehiclesMap__loading-el" />}
            containerElement={<div className="OperationalDashboardVehiclesMap__container-el" />}
            mapElement={<div className="OperationalDashboardVehiclesMap__map-el" />}
            data={data}
          />
        </div>
        {data && (
          <React.Fragment>
            <LeftColumn>
              <OperationalDashboardCard
                fullWidth
                title="Veículos"
                direction="column"
              >
                {data.vehicles && (
                  <React.Fragment>
                    <InfoWithProgressLine
                      color="green"
                      value={data.vehicles.available.quantity}
                      percentage={data.vehicles.available.percentage}
                      label="Disponíveis"
                      borderBottom
                    />
                    <InfoWithProgressLine
                      color="blue"
                      value={data.vehicles.loading.quantity}
                      percentage={data.vehicles.loading.percentage}
                      label="Carregando"
                      borderBottom
                    />
                    <InfoWithProgressLine
                      color="orange"
                      value={data.vehicles.inTransit.quantity}
                      percentage={data.vehicles.inTransit.percentage}
                      label="Em trânsito"
                      borderBottom
                    />
                    <InfoWithProgressLine
                      color="red"
                      value={data.vehicles.unavailable.quantity}
                      percentage={data.vehicles.unavailable.percentage}
                      label="Indisponíveis"
                    />
                  </React.Fragment>
                )}
              </OperationalDashboardCard>
            </LeftColumn>
            <RightColumn>
              <OperationalDashboardCard
                fullWidth
                title="Veículos em trânsito"
                direction="column"
              >
                {data.vehiclesInTransit && (
                  <React.Fragment>
                    <InfoWithProgressLine
                      color="green"
                      value={data.vehiclesInTransit.loadedRoundTrip.quantity}
                      percentage={data.vehiclesInTransit.loadedRoundTrip.percentage}
                      label="Carregados ida e volta"
                      borderBottom
                      flex={1}
                    />
                    <InfoWithProgressLine
                      color="orange"
                      value={data.vehiclesInTransit.emptyOnTheBack.quantity}
                      percentage={data.vehiclesInTransit.emptyOnTheBack.percentage}
                      label="Vazios na volta"
                      borderBottom
                      flex={1}
                    />
                  </React.Fragment>
                )}
                <VehiclesList vehicles={data.vehiclesInfo} />
              </OperationalDashboardCard>
            </RightColumn>
          </React.Fragment>
        )}
      </OperationalDashboard>
    );
  }
}

const mapStateToProps = state => ({
  data: state.operationalDashboardVehicles.data,
  isFetching: state.operationalDashboardVehicles.isFetching,
});

const mapActionsToProps = {
  getVehiclesData,
};

export default connect(mapStateToProps, mapActionsToProps)(Distribution);
